import React, {useMemo} from "react";
import CodeEditorPanel from "../../fieldMng/shared/CodeEditorPanel";
import CodeOptionTreeEditor from "../../fieldMng/shared/CodeOptionTreeEditor";

const DEPARTMENT_CHILD_LABELS = {
    title: "하위 부서",
    description: "선택한 부서 아래 하위 부서를 추가·수정합니다.",
    rootPlaceholder: "하위 부서명",
    addRootLabel: "+ 하위 부서 추가",
    addChildLabel: "+ 하위 부서",
    childPlaceholder: "하위 부서명",
    deleteTitle: "선택한 부서를 삭제하시겠습니까?",
    deleteDescription: "하위 부서가 있으면 삭제할 수 없습니다.",
    emptyMessage: "등록된 하위 부서가 없습니다. 위에서 부서를 추가하세요.",
};

function DepartmentCommonEditor({
    item,
    setItem,
    onSave,
    onDelete,
    onCreateChild,
    onUpdateChild,
    onDeleteChild,
}) {
    const editorItem = useMemo(() => {
        if (!item) {
            return null;
        }
        return {
            ...item,
            orders: item.sortOrder,
        };
    }, [item]);

    const setEditorItem = (updater) => {
        setItem((prev) => {
            const base = prev
                ? {...prev, orders: prev.sortOrder}
                : null;
            const next = typeof updater === "function" ? updater(base) : updater;
            if (!next) {
                return null;
            }
            const {orders, ...rest} = next;
            return {
                ...rest,
                sortOrder: orders ?? rest.sortOrder,
            };
        });
    };

    return (
        <div className="common-code-editor">
            <div className="common-code-editor__info">
                <CodeEditorPanel
                    category="common"
                    item={editorItem}
                    setItem={setEditorItem}
                    onSave={onSave}
                    onDelete={onDelete}
                    nameLabel="부서명"
                    deleteTitle="선택한 부서를 삭제하시겠습니까?"
                    deleteDescription="하위 부서가 있으면 삭제할 수 없습니다."
                    sectionTitle="부서 설정"
                    viewMode
                />
            </div>
            <div className="common-code-editor__options">
                <CodeOptionTreeEditor
                    parentId={item?.id}
                    options={item?.children ?? []}
                    onCreate={onCreateChild}
                    onUpdate={onUpdateChild}
                    onDelete={onDeleteChild}
                    labels={DEPARTMENT_CHILD_LABELS}
                />
            </div>
        </div>
    );
}

export default DepartmentCommonEditor;
